import React from 'react'

function Introduction({myName,myIntro,homeRef}) {
  return (
    <div className="introduction_container" ref={homeRef}>
        <div className="name">
           <span>नमस्ते world,</span>
           <br />
            <span>I am </span>
            <span className="name_span animate-charcter">{" " + myName}</span>
        </div>
        <div className="intro">
            {myIntro}
        </div>
    </div>
  )
}

export default Introduction